import type { UserProfile } from '../core/models/User'

export type ProfileUpdatedDetail = {
  profile: UserProfile
  userId: string | undefined
}

type ProfileChangeListener = (detail: ProfileUpdatedDetail) => void

const listeners = new Set<ProfileChangeListener>()

/** Subscribe to profile changes (same timing as `profileUpdated` window event). Unsubscribe with returned function. */
export function subscribeProfileChanges(listener: ProfileChangeListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function notifyListeners(detail: ProfileUpdatedDetail): void {
  listeners.forEach((fn) => {
    try {
      fn(detail)
    } catch {
      /* ignore subscriber errors */
    }
  })
}

/**
 * Single entry point for notifying legacy window listeners + in-process subscribers.
 * Keeps `profileUpdated` and `profileCachesCleared` in sync.
 */
export function notifyProfileObservers(args: {
  userId: string | undefined
  profile: UserProfile
}): void {
  const { userId, profile } = args

  const profileDetail: ProfileUpdatedDetail = { profile, userId }
  window.dispatchEvent(new CustomEvent<ProfileUpdatedDetail>('profileUpdated', { detail: profileDetail }))
  notifyListeners(profileDetail)

  window.dispatchEvent(new CustomEvent('profileCachesCleared', { detail: { userId } }))
}
